import FaresCarouselBackgroundImageContainerMobile from '../../../../components/containers/FaresCarouselBackgroundImageContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadFaresGridBackgroundImage';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fares-grid-background-image--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  containerConfig: {
    settings: {
      instance: FaresCarouselBackgroundImageContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
